import './App.less'
import routes from './routes'
import { useRoutes } from 'react-router-dom'

function App() {
	return useRoutes(routes())
}

export default App
